import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "menu", "toggle"];

  connect() {
    this.closeMenu();
    document.addEventListener("click", this.outsideClick);
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick);
  }

  toggle(event) {
    if (event.target.tagName.toLowerCase() !== "a") {
      event.preventDefault();
    }
    this.menuTarget.classList.toggle("hide");
  }

  select(event) {
    const item = event.currentTarget;
    const value = item.dataset.value;
    this.inputTarget.value = value;
    this.menuTarget.classList.add("hide");
    this.inputTarget.closest("form").requestSubmit();
    this.updateToggle(item);
  }

  closeMenu() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hide");
    }
  }

  outsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.closeMenu();
    }
  };

  updateToggle(item) {
    if (this.hasToggleTarget) {
      // Only show the score, not the date
      const iconDiv = item.querySelector(".condition-grade.micro");
      if (iconDiv) {
        this.toggleTarget.innerHTML = "";
        const iconClone = iconDiv.cloneNode(true);
        this.toggleTarget.appendChild(iconClone);
      }
    }
  }
}
